// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f4980d88","239":"4a41bfb1","762":"c630ad2f","849":"1805e0b0"}[chunkId] + ".chunk.js";
};